import { Stack, Typography } from '@customink/pigment-react';
import {
  usePricing,
  useProject,
} from '@customink/project-service-react-components';
import { TAX_EXEMPTION_STATUSES } from '@customink/project-service-types';

import { LineItem } from './LineItem';
import { TaxExemptionLineItem } from '../TaxExemption';

import { PgmntColorNeutralTextSecondary } from '@/utils/designTokens';

export function TaxLineItem() {
  const { data: pricingData } = usePricing();
  const { data: project } = useProject();

  const exemptStatus = project?.configuration?.taxExemption;
  const taxState = Object.values(pricingData.grouped)[0]?.state;

  const taxName = taxState ? (
    <>
      Tax
      <Typography color={PgmntColorNeutralTextSecondary} variant="uiTextTiny">
        {' '}
        ({taxState})
      </Typography>
    </>
  ) : (
    'Tax'
  );

  const taxValue =
    exemptStatus === TAX_EXEMPTION_STATUSES.EXEMPT ? (
      '$0.00'
    ) : (
      <Typography
        component="div"
        textAlign="right"
        variant="uiTextTiny"
        whiteSpace="nowrap"
      >
        Calculated&nbsp;at
        <br />
        Checkout
      </Typography>
    );

  return (
    <Stack spacing={0.25} useFlexGap>
      <LineItem
        name={taxName}
        sxName={{ alignSelf: 'flex-start' }}
        tagPrefix="tax"
        value={taxValue}
      />
      <TaxExemptionLineItem />
    </Stack>
  );
}
